<template>
    <div style="display: flex; flex-direction: column;">
        <main-swiper></main-swiper>
        <div class="contribute">
            <div class="contribute-item">
                <h2>
                    <img  @dragstart.prevent  src="../assets/icon_tg_tougao.png" class="icon" alt="" />
                    投稿赋能
                </h2>
                <p class="one-dec">为作者赋能，提供更多权益保障</p>
                <div class="one-compont">
                    <div class="one-compont-item" v-for="(item,index) in list" :key="index">
                        <img  @dragstart.prevent  :src="item.img" alt="">
                        <span>{{item.name}}</span>
                    </div>
                </div>
            </div>
            <div class="contribute-item">
                <h2>
                    <img  @dragstart.prevent  src="../assets/icon_tg_youxiang.png" class="icon" alt="" />
                    投稿邮箱
                </h2>
                <div class="contribute-item-bgc contribute-item-two">
                    <p>投稿邮箱：13121557965@163.com</p>
                    <div class="contribute-item-two-btn" @click="yxbtnClick">投稿</div>
                </div>
            </div>
            <div class="contribute-item">
                <h2>
                    <img  @dragstart.prevent  src="../assets/icon_tg_neirongyaoqiu.png" class="icon" alt="" />
                    作品内容要求
                </h2>
                <div class="contribute-item-bgc">
                    <p>1. 鼓励创新，投稿作品必须保持原创性，严禁抄袭，不得存在任何著作权瑕疵或纠纷</p>
                    <p>2. 风格类型不限，但内容需健康，积极向上，符合相关法律法规的要求</p>
                </div>
            </div>
            <div class="contribute-item">
                <h2>
                    <img  @dragstart.prevent  src="../assets/icon_tg_ziliaoyaoqiu.png" class="icon" alt="" />
                    收稿资料要求
                </h2>
                <div class="contribute-item-bgc">
                    <p>策划案大纲＋主角人设成稿＋1话分镜（成稿≥20格，含场景＋人物近远侧成稿）</p>
                    <p style="margin-top:20px">漫画要求</p>
                    <p>（1） 形式建议是手机漫画阅读的条漫</p>
                    <p>（2） 图片格式为png, jpg</p>
                    <p>（3） 尺寸：宽度为1280px，长度不限（成稿≥20格）</p>
                    <p>（4） 分辨率和色彩：300dpi, RGB</p>
                </div>
            </div>
            <div class="contribute-item">
                <h2>
                    <img  @dragstart.prevent  src="../assets/icon_tg_geshiyaoqiu.png" class="icon" alt="" />
                    作品内容要求
                </h2>
                <div class="contribute-item-bgc">
                    <p>1. 邮件主题：太原巴卡巴科技投稿＋【漫画/小说/剧本类】＋【男/ 女频】＋【品类】</p>
                    <p>2. 邮件需附附件，作品以压缩包形式并以（【漫画投稿＋ 【漫画/小说/剧本类】+【男/女频】＋【品类】）命名</p>
                </div>
            </div>
            <div class="contribute-item-two-btn subBtn" @click="yxbtnClick">投稿</div>
        </div>
    </div>
</template>

<script setup>
    import MainSwiper from '../components/mainSwiper.vue'
    import { ref } from "vue";
    let list = ref([
        {img:require('../assets/icon_tg_qianyuehezuo.png'),name:'签约合作'},
        {img:require('../assets/icon_tg_fenchengjili.png'),name:'分成激励'},
        {img:require('../assets/icon_tg_liuliangfuchi.png'),name:'流量扶持'},
        {img:require('../assets/icon_tg_shujvfenxi.png'),name:'数据分析'},
        {img:require('../assets/icon_tg_chuangzuobaozhang.png'),name:'创作保障'},
        {img:require('../assets/icon_tg_peixunzhidao.png'),name:'培训指导'},
    ])
    let yxbtnClick=()=>{
      window.location.href = "mailto:13121557965@163.com?subject=Subject&body=message%20goes%20here"; 
    }
</script>

<style lang="scss" scoped>
.contribute{
    min-width: 1188px;
    margin: 0 auto;
    padding: 40px 0 108px;
    display: flex;
    flex-direction: column;
    &-item{
        margin-bottom: 60px;
        &-bgc{
            padding: 30px;
            background: #FFFFFF;
            box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.2);
            border-radius: 10px;
            font-size: 16px;
            color: #333333;
            line-height: 28px;
        }
        &-two{
            display: flex;
            justify-content: space-between;
            align-content: center;
            p{
                line-height: 34px;
            }
        }
    }
    .contribute-item-two-btn{
        padding: 5px 30px;
        background: #CB2945;
        border-radius: 19px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
        cursor: pointer;
    }
    h2{
        display: flex;
        font-size: 28px;
        color: #333333;
        line-height: 40px;
        margin-bottom: 30px;
        img{
            width: 36px;
            height: 36px;
            margin-right: 12px;
        }
    }
    .one-dec{
        font-size: 16px;
        color: #CB2945;
        line-height: 22px;
        margin-bottom: 20px;
    }
    .one-compont{
        padding: 20px 30px;
        background: rgba(203,41,69,0.06);
        border-radius: 6px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        &-item{
            display: flex;
            align-items: center;
            img{
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
            span{
                font-size: 16px;
                color: #333333;
                line-height: 22px;
            }
        }
    }
    .subBtn{
        margin: 0 auto;
        padding: 7px 40px;
        border-radius: 21px;
    }
}
</style>